import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isDisabled", "isMultiSelect", "contentType", "selectedTags", "onChangeSelectedTags"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useCreateTags, useFetchTags } from 'actions/tags';
import { setAlert } from 'actions/alerts';
import useUniqueId from 'hooks/useUniqueId';
import FormField, { useFormFieldContext } from 'components/FormField';
import MultiSelect from 'components/MultiSelect';
import { formatTags, tagIcon } from 'components/FormFields/utils';
import Stack from 'components/Stack';
import Flex from 'components/Flex';
import HintTooltip from 'components/HintTooltip';
import Text from 'components/Text';
import InlineList from 'components/InlineList';
import Pill from 'components/Pill';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var NEW_TAG_ID = 'new-tag';
var TagField = function TagField(_ref) {
  var isDisabled = _ref.isDisabled,
    _ref$isMultiSelect = _ref.isMultiSelect,
    isMultiSelect = _ref$isMultiSelect === void 0 ? false : _ref$isMultiSelect,
    _ref$contentType = _ref.contentType,
    contentType = _ref$contentType === void 0 ? 'playlist' : _ref$contentType,
    _ref$selectedTags = _ref.selectedTags,
    selectedTags = _ref$selectedTags === void 0 ? [] : _ref$selectedTags,
    onChangeSelectedTags = _ref.onChangeSelectedTags,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useFormFieldContext = useFormFieldContext(),
    labelId = _useFormFieldContext.labelId;
  var _useCreateTags = useCreateTags(),
    createTags = _useCreateTags.createTags;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    tagInputValue = _useState2[0],
    setTagInputValue = _useState2[1];
  var _useFetchTags = useFetchTags(),
    providedTags = _useFetchTags.items,
    isLoading = _useFetchTags.isLoading,
    isError = _useFetchTags.isError;
  var uniqueId = useUniqueId();
  var commonTitleId = "common-".concat(uniqueId);
  var indeterminateTitleId = "indeterminate-".concat(uniqueId);

  // Filter all fetched tags by input value and remove already selected tags from dropdown
  var formattedTags = formatTags(providedTags.filter(function (tag) {
    return tag.name.includes(tagInputValue) && !selectedTags.some(function (selectedTag) {
      return selectedTag.value === tag.name;
    });
  }));
  var filteredTags = tagInputValue !== '' ? formattedTags.splice(0, 7) : [];

  // If current input was already a selected tag, prevent duplicate input
  var isDuplicate = selectedTags.some(function (t) {
    return t.value === tagInputValue;
  });
  if (isDuplicate) {
    filteredTags.unshift({
      id: '',
      name: t('alert_tag_already_added', {
        tag: tagInputValue
      }),
      value: "duplicate tag: ".concat(tagInputValue),
      icon: 'x',
      isDisabled: true
    });
  }

  // If no matching tag exists, show suggestion to add input as new tag in menu
  if (tagInputValue !== '' && !providedTags.filter(function (_ref2) {
    var name = _ref2.name;
    return name === tagInputValue;
  }).length) {
    filteredTags.unshift({
      id: NEW_TAG_ID,
      // This marks the tag as new
      name: t('actions_add_tag', {
        tag: tagInputValue
      }),
      value: tagInputValue,
      icon: tagIcon
    });
  }
  var createTag = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(newTagValue) {
      var tagValue, tag, _formatTags, _formatTags2, newTag, _t;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            tagValue = newTagValue.trim();
            _context.prev = 1;
            _context.next = 2;
            return createTags([tagValue]);
          case 2:
            tag = _context.sent;
            _formatTags = formatTags(tag), _formatTags2 = _slicedToArray(_formatTags, 1), newTag = _formatTags2[0];
            return _context.abrupt("return", newTag);
          case 3:
            _context.prev = 3;
            _t = _context["catch"](1);
            setAlert({
              key: 'add-my-team-playlist-tag',
              title: t('alert_tag_not_added', {
                tag: tagValue
              })
            });
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 3]]);
    }));
    return function createTag(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  var addTag = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(newTag) {
      var tag, newSelection;
      return _regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            tag = newTag;
            if (!(newTag.id === NEW_TAG_ID)) {
              _context2.next = 2;
              break;
            }
            _context2.next = 1;
            return createTag(newTag.value);
          case 1:
            tag = _context2.sent;
          case 2:
            newSelection = [].concat(_toConsumableArray(selectedTags), [tag]);
            onChangeSelectedTags({
              selectedItems: newSelection,
              itemsToAdd: tag,
              itemsToRemove: []
            });
            setTagInputValue('');
          case 3:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function addTag(_x2) {
      return _ref4.apply(this, arguments);
    };
  }();
  var removeTag = function removeTag(tag) {
    var newSelection = selectedTags.filter(function (t) {
      return t.id !== tag.id;
    });
    onChangeSelectedTags({
      selectedItems: newSelection,
      itemsToAdd: [],
      itemsToRemove: tag
    });
  };
  var indeterminateTags = selectedTags.filter(function (tag) {
    return tag.isIndeterminate;
  });
  var commonTags = selectedTags.filter(function (tag) {
    return !tag.isIndeterminate;
  });
  return /*#__PURE__*/_jsx(FormField, _objectSpread(_objectSpread({
    label: t('content_type_tag_plural')
  }, otherProps), {}, {
    children: /*#__PURE__*/_jsxs(Stack, {
      spacing: "xs",
      children: [/*#__PURE__*/_jsxs(Stack, {
        spacing: "xs",
        role: "group",
        "aria-labelledby": commonTitleId,
        children: [isMultiSelect && (commonTags.length > 0 || indeterminateTags.length > 0) && /*#__PURE__*/_jsxs(Flex, {
          children: [/*#__PURE__*/_jsx(Text, {
            id: commonTitleId,
            children: t('property_common')
          }), /*#__PURE__*/_jsx(HintTooltip, {
            content: t('hint_tags_common', {
              context: contentType,
              count: commonTags.length
            }),
            spacingLeft: "xs",
            vAlign: false
          })]
        }), /*#__PURE__*/_jsx(MultiSelect, {
          inputValue: tagInputValue,
          selectedItems: commonTags,
          options: filteredTags,
          optionsLabel: t('content_type_tag_plural'),
          onInputValueChange: function onInputValueChange(input) {
            return setTagInputValue(input);
          },
          onSelectItem: addTag,
          onRemoveItem: removeTag,
          getMenuItemLabel: function getMenuItemLabel(item) {
            return item.name;
          },
          emptyMenuMessage: isLoading ? t('loading') : isError ? t('error_500') : '',
          isDisabled: isDisabled
        })]
      }), indeterminateTags.length > 0 && /*#__PURE__*/_jsxs(Stack, {
        spacing: "xs",
        role: "group",
        "aria-labelledby": indeterminateTitleId,
        children: [/*#__PURE__*/_jsxs(Flex, {
          children: [/*#__PURE__*/_jsx(Text, {
            id: indeterminateTitleId,
            children: t('property_individual')
          }), /*#__PURE__*/_jsx(HintTooltip, {
            content: t('hint_tags_individual', {
              context: contentType,
              count: indeterminateTags.length
            }),
            spacingLeft: "xs",
            vAlign: false
          })]
        }), /*#__PURE__*/_jsx(InlineList, {
          spacing: "xxs",
          "aria-labelledby": labelId,
          children: isDisabled ? indeterminateTags.map(function (tag) {
            return /*#__PURE__*/_jsx(Pill, {
              icon: "tag",
              children: tag.name
            }, tag.id);
          }) : indeterminateTags.map(function (tag) {
            return /*#__PURE__*/_jsx(Pill, {
              icon: "tag",
              deleteLabel: t('actions_delete'),
              onDelete: function onDelete() {
                return removeTag({
                  id: tag.id
                });
              },
              children: tag.name
            }, tag.id);
          })
        })]
      })]
    })
  }));
};
export default TagField;